import { Navigate, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { getWorkflows } from '@/services/api'
import { OrderConfirmationLayout } from '@/features/order-confirmation/pages/OrderConfirmationLayout'
import { useActingAs } from '@/state/actingAs'

export function WorkflowPage() {
  const { workflowId } = useParams<{ workflowId: string }>()
  const actingAs = useActingAs()

  // Keyed by the acting-as org so this doesn't collide with the FrontFlow-org
  // sidebar's own ['workflows', null] cache entry — otherwise admin act-as can
  // silently serve the admin's own workflow list here instead of the
  // impersonated org's.
  const { data: workflows, isLoading } = useQuery({
    queryKey: ['workflows', actingAs?.organizationId ?? null],
    queryFn: getWorkflows,
  })

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-24 text-sm text-gray-400">
        Loading…
      </div>
    )
  }

  const workflow = workflows?.find((w) => w.id === workflowId)

  if (!workflow) {
    return <Navigate to="/" replace />
  }

  if (workflow.type === 'oc') {
    return <OrderConfirmationLayout />
  }

  // Sales order lives under its own prefix, so a /workflow link to one — an old bookmark, or a
  // link built before the type was known — is sent on rather than dropped at the front page.
  if (workflow.type === 'so') {
    return <Navigate to={`/sales-order/${workflowId}/overview`} replace />
  }

  return <Navigate to="/" replace />
}
